import { render, staticRenderFns } from "./RibbonDependencies.vue?vue&type=template&id=4d693669&scoped=true&"
import script from "./RibbonDependencies.vue?vue&type=script&lang=js&"
export * from "./RibbonDependencies.vue?vue&type=script&lang=js&"
import style0 from "./RibbonDependencies.vue?vue&type=style&index=0&id=4d693669&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d693669",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
